var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-alert",
        {
          attrs: {
            title: "Error en la descarga",
            active: "true",
            color: "danger"
          }
        },
        [_vm._v(" El archivo requerido no existe ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }